import React, { useEffect, useRef } from "react";
import tw from "twin.macro";
import styled from "styled-components";
import Navbar from "../../../Navbar/Navbar.js";
import LocationTracking from "../../../../Images/location_tracking.svg";
import map from "../../../../Images/google_map.png";
import location from "../../../../Images/google-maps.png";
import experian from "../../../../Images/experian.jpg";
import usps_logo from "../../../../Images/us_postal_service.png";
import ca_logo from "../../../../Images/department_of_real-estate.png";
import zip_logo from "../../../../Images/zip.jpg";
import arcGIS from "../../../../Images/arcGIS.png";
import esri from "../../../../Images/esri.jpg";
import Footer from "../../../Footer/Footer.js";
import imageHeader from "../../../../resources/imageHeader.json";
import logoData from "../../../../resources/logoTextData.json";
import ImageHeader from "../ImageHeader.js";
import Header, {
  NavLink,
  NavLinks,
  LogoLink,
  NavToggle,
  DesktopNavLinks,
} from "../../../Navbar/Navbar.js";
import { useNavigate } from "react-router-dom";
import BreadCrumbs from "../BreadCrumbs.js";
import ContactUsButton from "../ContactUsButton.js";
import LogoCard from "../LogoCard.js";
import BackButton from "../BackButton.js";
import ImageHeaderMain from "../ImageHeaderMain.js";

const Container = tw.div`relative  bg-center 
bg-no-repeat
h-screen
w-full  `;
const StyledHeader = styled(Header)`
  ${tw`pt-8 max-w-none text-gray-800 bg-white z-10`}
  ${DesktopNavLinks} ${NavLink}, ${LogoLink} {
    ${tw`text-gray-100 hover:border-gray-300 hover:text-gray-300`}
  }
  ${NavToggle}.closed {
    ${tw`text-gray-100 hover:text-primary-500`}
  }
`;
const OpacityOverlay = tw.div`z-10 absolute inset-0 bg-pink-700 opacity-25`;
const HeroContainer = tw.div`z-20 relative px-4 sm:px-8 max-w-screen-2xl mx-auto`;
const ContainerNav = styled.div`
  ${tw`relative`}
`;
const Wrapper = tw.div`max-w-screen-xl mx-auto py-2  mb-20`;

let logosData =
  logoData.thirdpartyintegrations.integrationspecialities[0].insideData;
let imgArr = [
  {
    img1: map,
    img2: location,
  },
  {
    img1: usps_logo,
    img2: ca_logo,
    img3: zip_logo,
  },
  {
    img1: experian,
  },
  {
    img1: arcGIS,
    img2: esri,
  },
];

const LocationIntegration = () => {
  useEffect(()=>{
    document.title="Welcome to Iqura - Location & Address Integrations"
    let descMeta=document.querySelector("meta[name='description']")
    descMeta.setAttribute("content", 'Iqura third party integration of location and address information in the real estate industry involves leveraging geolocation technology, location insights platforms, MLS integration, real estate APIs, and mapping solutions to provide users with accurate, comprehensive, and intuitive location-based data for informed decision-making')
    let keyword=document.querySelector("meta[name='keywords']")
    keyword.setAttribute("content", "Google Maps APIs, Address validation and verification APIs, Experian APIs, ESRI and ArcGIS APIs")
    },[]);

  const svgStyle = {
    backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1440 320'%3E%3Cpath fill='%23EEF5FF' fill-opacity='0.9' d='M0,96L48,101.3C96,107,192,117,288,122.7C384,128,480,128,576,117.3C672,107,768,85,864,80C960,75,1056,85,1152,117.3C1248,149,1344,203,1392,229.3L1440,256L1440,0L1392,0C1344,0,1248,0,1152,0C1056,0,960,0,864,0C768,0,672,0,576,0C480,0,384,0,288,0C192,0,96,0,48,0L0,0Z'/%3E%3C/svg%3E")`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    height: "350px",
  };

  const navigate = useNavigate();
  const navLinks = [
    <NavLinks key={1}>
      <NavLink onClick={() => navigate("/", { state: "whatwedo" })}>
        What we do
      </NavLink>
      <NavLink onClick={() => navigate("/", { state: "ourservices" })}>
        Services
      </NavLink>
      <NavLink onClick={() => navigate("/", { state: "techstack" })}>
        Techstack
      </NavLink>
      <NavLink onClick={() => navigate("/", { state: "whoweare" })}>
        Who we are
      </NavLink>
      <NavLink onClick={() => navigate("/", { state: "career" })}>
        Careers
      </NavLink>
      <NavLink onClick={() => navigate("/", { state: "contact" })}>
        Contact
      </NavLink>
    </NavLinks>,
  ];
  const childRef = useRef(null);
  const handleBreadCrumbClose = () => {
    if (childRef.current) {
      childRef.current.handleClick();
    }
  };

  return (
    <>
    <Navbar className="shadow-md" />
      <ContainerNav>
        <OpacityOverlay />
        <HeroContainer>
          <StyledHeader links={navLinks} />
        </HeroContainer>
      </ContainerNav>
      <BreadCrumbs ref={childRef} title={"Third-Party  API Integrations"} title1={"What we do"} bgcolor={"#EEF5FF"} /> 
      <ContactUsButton />
      <Container style={svgStyle} onClick={handleBreadCrumbClose}>
        <ImageHeaderMain
          imageHeaderData={imageHeader.LocationAddress}
          imgsource={LocationTracking}
        />
        {/* <ThreeColumnContainer>{integrationSpecialities}</ThreeColumnContainer> */}
        <Wrapper>
          <BackButton/>
          {/* <SubHeadings heading1="Integration" heading2="Specialities" /> */}
          <LogoCard data={logosData} imgArr={imgArr} />
        </Wrapper>
        <Footer />
      </Container>
    </>
  );
};

export default LocationIntegration;
